import { propEq, find } from 'ramda'
import groupAvatar from '@/features/Chat/images/group-avatar.svg'
import { getImageUrl } from '@/utils/image'

export const getPrimaryOther = (users, primary_user_ids) =>
  find(propEq('id', primary_user_ids?.them))(users?.them)

export const getIsGroupChat = (users = {}) => users.them.length > 1 || users.us.length > 1

export const getChatAvatar = (users, primary_user_ids, size = 100) => {
  const primaryOther = getPrimaryOther(users, primary_user_ids)
  const isGroupChat = getIsGroupChat(users)
  return isGroupChat
    ? groupAvatar
    : getImageUrl(primaryOther?.avatar?.aws_s3_key, {
        width: size,
        height: size
      })
}

export function isIOS() {
  const windows = new RegExp('windows', 'i')
  const ios = new RegExp('(ipod|iphone|ipad)', 'i')
  const ua = navigator.userAgent
  return !windows.test(ua) && ios.test(ua)
}
